export interface ITestLogger {
    log(message: string, customFields: Record<string, number | string | boolean | undefined>): void;
}

export interface ILogItem {
    message: string;
    fields: Record<string, number | string | boolean | undefined>;
}

const sessionStorageKey = "Candy:TestLogs";

function clearLogItems(): void {
    try {
        if (sessionStorage.getItem(sessionStorageKey) != undefined) {
            sessionStorage.removeItem(sessionStorageKey);
        }
    } catch {
        // ignore errors
    }
}

export function getStoredLogItems(): ILogItem[] | undefined {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return JSON.parse(sessionStorage.getItem(sessionStorageKey) ?? "[]");
    } catch {
        sessionStorage.removeItem(sessionStorageKey);
        return undefined;
    }
}

class EmptyTestLogger implements ITestLogger {
    public log(): void {
        // noop
    }
}

const singleton = new EmptyTestLogger();

export function getTestLoggerInstance(): ITestLogger {
    clearLogItems();
    return singleton;
}
